import styled from 'styled-components';
import { Button } from '@sainsburys-tech/bolt';
var StoreSelectorModal = styled.div.withConfig({
  displayName: "StoreSelectorstyles__StoreSelectorModal",
  componentId: "sc-764iux-0"
})(["position:fixed;z-index:10001;top:0;left:0;width:100%;height:100%;min-width:320px;"]);
var ModalContent = styled.div.withConfig({
  displayName: "StoreSelectorstyles__ModalContent",
  componentId: "sc-764iux-1"
})(["width:100%;height:100%;max-height:100%;max-width:100%;padding-top:80px;position:absolute;z-index:2;top:0;left:0;transform:none;background-color:", ";box-shadow:0 0 10px rgba(0,0,0,0.6);display:flex;flex-direction:column;overflow:hidden;-webkit-font-smoothing:antialiased;@media (min-width:", "){top:50%;left:50%;width:90%;height:90%;transform:translate(-50%,-50%);max-height:90%;max-width:670px;min-width:auto;}"], function (props) {
  return props.theme.color.monochrome.white;
}, function (props) {
  return props.theme.size.breakpoint['min-width'].sm;
});
var ModalInner = styled.div.withConfig({
  displayName: "StoreSelectorstyles__ModalInner",
  componentId: "sc-764iux-2"
})(["width:100%;max-height:initial;overflow:auto;-webkit-overflow-scrolling:touch;flex:1 1 auto;"]);
var ModalInnerSection = styled.div.withConfig({
  displayName: "StoreSelectorstyles__ModalInnerSection",
  componentId: "sc-764iux-3"
})(["background:", ";min-height:calc(90vh - 204px);"], function (props) {
  return props.theme.color.monochrome.lighter;
});
var ModalOverlay = styled.div.withConfig({
  displayName: "StoreSelectorstyles__ModalOverlay",
  componentId: "sc-764iux-4"
})(["position:absolute;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,0.3);"]);
var ModalHeader = styled.div.withConfig({
  displayName: "StoreSelectorstyles__ModalHeader",
  componentId: "sc-764iux-5"
})(["position:absolute;top:0;right:0;left:0;z-index:3;display:flex;align-items:center;padding:15px;border-bottom:1px solid ", ";h3{margin:0;flex-grow:1;}"], function (props) {
  return props.theme.color.monochrome.light;
});
var ModalCloseButton = styled(Button).withConfig({
  displayName: "StoreSelectorstyles__ModalCloseButton",
  componentId: "sc-764iux-6"
})(["padding:12px;border:none;cursor:pointer;color:", ";svg{fill:inherit;width:25px;height:25px;}&:focus{background-color:transparent;}"], function (props) {
  return props.theme.color.monochrome.base;
});
var ContentPlaceholderGroup = styled.div.withConfig({
  displayName: "StoreSelectorstyles__ContentPlaceholderGroup",
  componentId: "sc-764iux-7"
})(["padding-top:15px;"]);
export { StoreSelectorModal, ModalContent, ModalInner, ModalInnerSection, ModalOverlay, ModalCloseButton, ContentPlaceholderGroup, ModalHeader };